import { render, staticRenderFns } from "./set09.vue?vue&type=template&id=42a2567c&scoped=true&"
import script from "./set09.vue?vue&type=script&lang=js&"
export * from "./set09.vue?vue&type=script&lang=js&"
import style0 from "./set09.vue?vue&type=style&index=0&id=42a2567c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a2567c",
  null
  
)

export default component.exports